import { render, staticRenderFns } from "./redpool.vue?vue&type=template&id=58f7f514&scoped=true"
import script from "./redpool.vue?vue&type=script&lang=js"
export * from "./redpool.vue?vue&type=script&lang=js"
import style0 from "./redpool.vue?vue&type=style&index=0&id=58f7f514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f7f514",
  null
  
)

export default component.exports